import React, { useEffect } from 'react';
import { defer } from 'lodash';

import useSheet from '../structural/sheet/hooks/useSheet';
import useContextMenuGestureRecognizer from '../../workspace/touchGestures/useContextMenuGestureRecognizer';

import MobileCanvasContextMenuContent from './MobileCanvasContextMenuContent';
import SheetContainer, { Content, Overlay, Sheet } from '../structural/sheet';

import { SheetId } from '../structural/sheet/sheetTypes';

// on mobile we use a custom event to trigger the context menu
// this is because the default context menu event on android can occur at unexpected times.
// since the handling of this "context menu" is 100% custom,
// we can control when it is opened more clearly by using a custom event.
const CONTEXT_MENU_EVENT_NAME = 'mobile_contextmenu';

type MobileContextMenuProps = {
    workspaceRef: React.RefObject<HTMLDivElement>;
};

const MobileCanvasContextMenu = ({ workspaceRef, ...rest }: MobileContextMenuProps) => {
    const sheetProps = useSheet(SheetId.CanvasContextMenu);

    useContextMenuGestureRecognizer(workspaceRef, CONTEXT_MENU_EVENT_NAME);

    const openContextMenu: EventListener = (event: Event) => {
        event.preventDefault();

        // defer is used to ensure that the context menu is opened _after_ the click event has been processed.
        // otherwise the context menu might be closed immediately after opening.
        defer(sheetProps.dispatchOpenSheet);
    };

    useEffect(() => {
        workspaceRef.current?.addEventListener(CONTEXT_MENU_EVENT_NAME, openContextMenu);

        return () => {
            workspaceRef.current?.removeEventListener(CONTEXT_MENU_EVENT_NAME, openContextMenu);
        };
    }, []);

    return (
        <SheetContainer defaultSnapPoint={'0.5max'} {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <MobileCanvasContextMenuContent {...rest} />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileCanvasContextMenu;
